'use client'

import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useReturnsInfo } from 'shipping-and-returns/hooks/useReturnsInfo/useReturnsInfo'
import { cx } from 'utils/cx'

export function OrderStatusReturnInfo({
	className,
}: {
	readonly className?: string
}) {
	const { maximumReturnDays } = useReturnsInfo()
	const { t } = useLabels()

	const returnDaysPlaceholder = {
		1: maximumReturnDays,
	}

	return (
		<div className={cx(className)}>
			<h2>{t('myPurchases.orderStatus.returns.title')}</h2>
			<p>
				<ClientLabel placeholderValues={returnDaysPlaceholder}>
					{t('myPurchases.orderStatus.returns.subtitle')}
				</ClientLabel>
			</p>
		</div>
	)
}
